// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { SquareBoxesFragmentDoc } from './squareBoxes.fragment.generated';
export const ComponentSquareBoxesFragmentDoc = gql`
    fragment componentSquareBoxes on ComponentSquareBoxes {
  items {
    ...squareBoxes
  }
}
    ${SquareBoxesFragmentDoc}`;